import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    limit: number = 20,
    trail: string = '…',
    excludeSpaces: boolean = false
  ): string {
    if (!value) {
      return '';
    }

    if (!excludeSpaces) {
      return value.length > limit ? value.slice(0, limit) + trail : value;
    }

    if (value.replace(/\s/g, '').length <= limit) {
      return value;
    }

    let nonSpaceCount = 0;
    let cutIndex = value.length;
    for (let i = 0; i < value.length; i++) {
      if (!/\s/.test(value[i])) {
        nonSpaceCount++;
      }
      if (nonSpaceCount === limit) {
        cutIndex = i + 1;
        break;
      }
    }

    return value.slice(0, cutIndex) + trail;
  }
}
